<template>
  <q-form class="event-sponsor-photo-form q-mb-md" @submit.prevent="$emit('form-submit')">
    <p class="q-mb-sm">
      {{ $t('events.sponsorPhoto.modalInfo') }}
    </p>

    <p class="q-mb-lg event-text-warning" v-if="isAfterStartDate">
      <span>{{ $t('events.sponsorPhoto.modalWarning') }}</span>
    </p>

    <div class="col-xs-12 col-sm-4 sponsor-image-preview" v-if="event.sponsor_image">
      <q-img :src="event.sponsor_image" fit="contain" class="sponsor-image-preview__img" />
    </div>

    <q-file
      :readonly="isAfterStartDate"
      v-model="form.eventSponsorImage"
      :label="$t('events.sponsorPhoto.eventImageField')"
      accept=".jpeg, .jpg, .png"
      max-file-size="5242880"
      hide-bottom-space
      @rejected="onFileRejected"
    >
      <template #append>
        <q-icon name="cloud_upload" />
      </template>
    </q-file>
    <div class="flex justify-end" v-if="!isAfterStartDate">
      <q-btn
        type="submit"
        color="primary"
        label="Zapisz"
        class="q-mt-lg"
        :loading="isLoading"
      />
    </div>
  </q-form>
</template>

<script>
import userRoleMixin from "@/mixins/userRoleMixin";
import moment from 'moment';
import { handleFileRejected } from "@/helpers/fileHelper";

export default {
  name: "EventSponsorImageForm",
  mixins: [userRoleMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: { ...this.formData },
      eventSponsorImage: null
    };
  },
  methods: {
    onFileRejected(rejectedEntries) {
      handleFileRejected(rejectedEntries, this.$t);
    },
  },
  computed: {
    isAfterStartDate () {
      if (!this.event?.startDate) {
        return false
      }

      return moment().isAfter(moment(this.event.startDate))
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.form)) {
          this.form = { ...newVal };
        }
      },
    },
    form: {
      handler(newVal) {
        this.$emit("update", newVal);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .event-sponsor-photo-form{
    :deep(.q-field__inner) {
      background: #f8f8f8;
      padding: 10px;
    }
  }
  .event-text-warning{
    color: $red-9;
  }

  .sponsor-image-preview {
    max-width: 400px;
    margin: 8px auto;

    &__img {
      width: 100%;
      max-height: 400px;
      border-radius: 8px;
      background: $accent-light;
      overflow: hidden;
    }
  }
</style>
